import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jweb-mpscript-servlet',
	templateUrl:'./JWebMPScriptServletPluginCompPage.html',
	styles: [],
	styleUrls:['./JWebMPScriptServletPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JWebMPScriptServletPluginCompPage
{
	mdContent_1048 = `\`\`\`java
import com.jwebmp.vertx.JWebMPScriptServlet;
\`\`\``;
	mdContent_1049 = `\`\`\`java
JWebMPScriptServlet()
\`\`\``;
	mdContent_1050 = `\`\`\`java
// The site-loader script is automatically injected:
// <script src="/jwscr"></script>
// It initializes the JWebMP client framework,
// registers event handlers, and sets up AJAX communication
\`\`\``;
}
